<template>
  <v-row justify="center" align="start">
    <v-col cols="12" lg="12" md="12" xs="12" v-if="viewName != 'search'">
      <v-banner icon="info">
        Additional Product Information
        <template v-slot:actions>
          <v-btn
            text
            color="blue darken-2"
            exact
            @click.prevent="goBack()"
            v-if="viewName == 'standing' || viewName == 'template'"
          >
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
          <v-btn
            text
            color="blue darken-2"
            exact
            @click.prevent="handleBack('/')"
            v-else
          >
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </template>
      </v-banner>
    </v-col>

    <v-col cols="12" lg="3" md="12" xs="12" v-if="viewName != 'search'">
      <ProductImage :product="product"></ProductImage>
    </v-col>
    <v-col cols="12" :md="viewName != 'search' ? '9' : '12'" xs="12">
      <v-row justify="start" align="start">
        <v-col cols="12" xs="12" class="pt-0" v-if="viewName != 'search'">
          <ProductName :product="product"></ProductName>
        </v-col>
        <v-col cols="12" xs="12">
          <div class="subtitle-2">Description</div>
          <div>{{ this.longDescription }}</div>
        </v-col>

        <v-col cols="12" xs="12">
          <div class="subtitle-2">Ingredients</div>
          <div>{{ this.ingredients }}</div>
        </v-col>

        <v-col cols="12" xs="12" v-if="hasSpecsheet">
          <div class="subtitle-2">Product Spec</div>
          <div>
            <a :href="prodSpecSheet" target="_blank"
              >Click here to open the product specification PDF</a
            >
          </div>
        </v-col>

        <v-col cols="12" xs="12">
          <div class="subtitle-2">Allergy Information</div>
          <ProductAllergen :product="productAllergens"></ProductAllergen>
        </v-col>

        <v-col cols="12" xs="12">
          <div class="subtitle-2">Nutritional Information</div>
          <ProductNutrition :product="prodNutrition"></ProductNutrition>
        </v-col>

        <v-col cols="12" xs="12">
          <v-card outlined>
            <v-card-title>
              <v-icon class="mr-2" color="blue darken-2">info</v-icon>Important
              Information
            </v-card-title>
            <v-card-text><div v-html="allergenText"></div></v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ProductImage from "@/components/product/ProductImage.vue";
import ProductName from "@/components/product/ProductName.vue";
import ProductAllergen from "@/components/product/ProductAllergen.vue";
import ProductNutrition from "@/components/product/ProductNutrition.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ProductImage,
    ProductName,
    ProductAllergen,
    ProductNutrition,
  },

  props: {
    viewName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      fromRoute: null,
      productAllergens: {},
      prodNutrition: {},
      product: {},
      hasSpecsheet: false,
    };
  },

  mounted() {
    console.log("-- Activated Product");
    this.product = this.$route.params.product;
    console.log(this.product);
    this.getProductAllergens();
    this.getProductNutrition();
    this.getProductSpechseet();
    window.scrollTo(0, 0);
  },

  activated() {
    console.log("-- Activated Product");
    this.product = this.$route.params.product;
    console.log(this.product);
    this.getProductAllergens();
    this.getProductNutrition();
    this.getProductSpechseet();
    window.scrollTo(0, 0);
  },

  computed: {
    ...mapGetters(["retrieveUser", "retrieveAllergenText"]),
    longDescription() {
      if (this.product) {
        if (this.product.long_description != "") {
          return this.product.long_description;
        }
      }

      return "No product description available";
    },

    ingredients() {
      if (this.product) {
        if (this.product.ingredients != "") {
          return this.product.ingredients;
        }
      }

      return "No ingredient information available";
    },

    productNumber() {
      if (this.product) {
        return this.product.prod_no;
      }

      return null;
    },

    allergenText() {
      let a_text = this.$store.getters.retrieveAllergenText;

      if (a_text) {
        return a_text;
      }

      return "While every care has been taken to ensure product information is correct, food products are constantly being reformulated, so ingredients, nutrition content, dietary and allergens may change. <br/> Please do not solely rely on the information provided on this website. <br/> Although product information is regularly updated, we are unable to accept liability for any inaccurate or incorrect information. <br/> This does not affect your statutory rights.";
    },

    rec() {
      return Object.assign(
        {},
        { userId: this.retrieveUser.userNum },
        { sessionKey: this.retrieveUser.sessionKey },
        { prod_no: this.productNumber }
      );
    },
    prodSpecSheet() {
      return (
        process.env.VUE_APP_CATERPOINT +
        "/specsheets/pss_" +
        this.product.prod_no +
        ".pdf"
      );
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromRoute = from;
    });
  },

  methods: {
    ...mapActions([
      "fetchProductAllergens",
      "fetchProductNutritions",
      "fetchAllergenText",
      "fetchProductSpecsheet",
    ]),

    getProductAllergens() {
      this.fetchProductAllergens(this.rec)
        .then((response) => {
          if (response.success == true) {
            this.productAllergens = response.allergens;
            console.log(this.productAllergens);
            console.log("Populating Allergens...");
          } else {
            console.log("Error Fetching Allergen Report");
          }
        })
        .catch((er) => {
          console.log(er);
        });
    },
    getProductNutrition() {
      this.fetchProductNutritions(this.rec)
        .then((response) => {
          if (response.success == true) {
            this.prodNutrition = response.nutrition;

            console.log("Populating Nutrients...");
          } else {
            console.log("Error Fetching Nutrition Report");
          }
        })
        .catch((er) => {
          console.log(er);
        });
    },

    getProductSpechseet() {
      this.fetchProductSpecsheet(this.rec)
        .then((response) => {
          if (response.success == true) {
            this.hasSpecsheet = response.hasSpecsheet;
          } else {
            this.hasSpecsheet = false;
            console.log("Error Fetching Product Specs");
          }
        })
        .catch((er) => {
          console.log(er);
        });
    },

    goBack() {
      this.$router.back();
    },

    /**
     * Handle Back
     * @desc Extends default router back functionality
     * @param {string} fallback - The fallback path if there is no history to use with $router.back(). This is usually the case if the page was visited directly or from another site
     **/
    handleBack(fallback) {
      if (this.fromRoute) {
        if (!this.fromRoute.name) {
          this.$router.push(fallback);
        } else {
          this.goBack();
        }
      } else {
        this.goBack();
      }
    },
  },
};
</script>

<style lang="sass" scoped></style>
